import React from 'react';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import {Link as RouterLink} from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Form from './Form';

export default class UpdateTheme extends React.Component {
    render() {
        return <>
            <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" component={RouterLink} to="/themes">
                    All themes
                </Link>

                <Typography color="textPrimary">Update</Typography>
            </Breadcrumbs>

            <Box mt={3}>
                <Form id={this.props.match.params.id}/>
            </Box>
        </>;
    }
}
